<template>
  <div class="form-member-choose">
    <div v-if="showUsers" class="member-btn">
      <div v-if="!isText" class="open" @click="openD">
        <slot>
          <el-button size="small" type="primary">{{ title }}</el-button>
        </slot>
      </div>
      <div class="member-list" :class="{'has-user': showList.length > 0 && !isText}">
        <el-tag
          v-for="(item, index) in showList"
          :key="index + 'member'"
          :closable="!isText"
          type="info"
          style="margin-right: 8px; margin-bottom: 8px"
          @close="deletItem(index, item)"
        >
          <span>
            {{ item.name || item.departmentName }}
          </span>
        </el-tag>
      </div>
    </div>
    <el-dialog title="选择角色" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" custom-class="hasborder-dialog" width="640px" :before-close="handleClose">
      <div class="member member-flex member-jsb">
        <div class="member-left">
          <el-input v-model="searchInfo" :clearable="true" size="small" placeholder="搜索角色" suffix-icon="el-icon-search" @input="debounceSearch" />
          <div v-if="allList.length > 0" class="scrollbar-wrapper">
            <el-checkbox v-show="leftList.length > 0" v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 8px 0;" />
            <el-checkbox-group v-model="checkList">
              <div v-for="(item, index) in leftList" :key="index" class="role-checkbox-item">
                <el-checkbox :label="item.id" @change="(val) => changeCheckbox(val, item)">{{ item.name || '' }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="member-right" @scroll.passive="handleTooltipScroll">
          <div class="member-right-header member-flex member-jsb">
            <p class="member-right-text">已选角色（ {{ roleList.length }}/{{ allList.length }} ）</p>
          </div>
          <div class="member-choosed">
            <div v-for="(item, index) in roleList" :key="'choosed' + index">
              <p>{{ item.name }}</p>
              <i class="el-icon-close" @click="removeRole(index, item)" />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="line-btn" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// src\views\approvalCenter\api\index.js
import { deepClone } from '@/utils'
import { getRoleList } from '@/api/form'
// 搜索点击限制频数
import { debounce } from '@/utils/index'
import cloneDeep from 'lodash/cloneDeep'
import { mapState } from 'vuex'
// import { getVisibleDepartEnterpriseList, getVisibleUserEnterpriseList } from '@/api'
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    // 分支中文描述
    info: {
      type: String,
      default: ''
    },
    isText: {
      type: Boolean, // 只展示内容
      default: false
    },
    showUsers: {
      type: Boolean, // 展示tag标签
      default: false
    },
    title: {
      type: String,
      default: '选择角色'
    },
    // 限制选择人数
    limit: {
      type: Number,
      default: 0
    },
    defaultDisabled: {
      type: Boolean, // 默认值不可选
      default: false
    },
    hideDefault: {
      type: Boolean, // 隐藏默认角色
      default: false
    },
    isInner: {
      type: Boolean, // 默认值不可选
      default: false // 是否只选择内部角色
    }
  },
  data() {
    return {
      dialogVisible: false,
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      leftList: [],
      allList: [], // 所有数据
      allListMap: {}, // 所有有人id
      mapList: [], // 人员数组
      checkList: [], // 角色选择
      roleList: [], // 右侧选中的角色
      activeIDList: [], // 当前选中的人员id数组
      activeList: [], // 当前选中的人员数组
      chooseList: [], // 上次选中的人员数组
      dataList: [],
      defaultExpandedKeys: [],
      defaultProps: {
        children: 'childList',
        value: 'value'
      }, // 修改树形结构默认对应的字段名字
      checkAll: false, // 是否全选人员
      isShowTree: true, //
      isIndeterminate: false, //
      departmentId: null, // 部门id
      searchInfo: null, // 输入框值
      activeObject: {}, // 当前选中的部门对象
      disabledTooltip: false // 滚动中tooltip无效
    }
  },
  computed: {
    ...mapState('async', ['rolesMap']),
    showList() {
      const showList = []
      this.value.map((id) => {
        const rolrItem = this.rolesMap[id] || this.allListMap[id]
        if (rolrItem) {
          showList.push(rolrItem)
        }
      })
      return showList
    }
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.getRoleListData()
    }
  },
  methods: {
    // 获取角色列表
    async getRoleListData() {
      try {
        const res = await getRoleList({ departmentIds: [], isInner: this.isInner })
        if (res && res.code === 200) {
          if (this.hideDefault) {
            this.allList = res.data.filter((item) => item.isDefault !== 1)
            this.leftList = res.data.filter((item) => item.isDefault !== 1)
          } else {
            this.allList = res.data
            this.leftList = res.data
          }
          this.initDefault()
          const allListMap = {}
          this.allList.map((item) => {
            if (item.id) {
              allListMap[item.id] = item
            }
          })
          this.allListMap = Object.freeze(allListMap)
        }
        this.checkAllValue()
      } catch (err) {
        console.log(err)
      }
    },
    // 初始化选中
    initDefault() {
      if (!this.checkList.length) {
        this.checkList = this.value
      }
      const roleList = []
      this.checkList.map((id) => {
        const rolrItem = this.allList.find((item) => item.id === id)
        if (rolrItem) {
          roleList.push(rolrItem)
        }
      })
      this.roleList = roleList
    },
    // 选人角色
    changeRole() {
    },
    removeRole(index, item) {
      this.roleList.splice(index, 1)
      this.checkList = this.checkList.filter((item2) => item2 !== item.id)
      this.checkAllValue()
    },
    // 删除人员
    deletItem(index, item) {
      this.checkList = this.checkList.filter((item2) => item2 !== item.id)
      this.roleList = this.roleList.filter((item2) => item2.id !== item.id)
      this.chooseList.splice(index, 1)
      this.$emit('input', this.checkList)
      this.$emit('validateProp')
      this.sendInfo()
    },
    // 滚动时不显示tooltip
    handleTooltipScroll() {
      this.disabledTooltip = true
      if (this.toolTipTimer) {
        clearTimeout(this.toolTipTimer)
      }
      this.toolTipTimer = setTimeout(() => {
        this.disabledTooltip = false
      }, 200)
    },
    // 搜索节流
    debounceSearch: debounce(function() {
      this.getDataMapList()
    }, 1000),
    // 角色筛选
    async getDataMapList() {
      this.leftList = this.allList.filter((item) => {
        return item.name.includes(this.searchInfo)
      })
      this.checkAllValue()
    },
    checkAllValue() {
      const leftListIds = this.leftList.map((item) => item.id)
      const arr = this.checkList.filter(item => {
        return leftListIds.indexOf(item) !== -1
      })
      if (this.checkList.length === 0) {
        this.checkAll = false
        this.isIndeterminate = false
      } else if (arr.length === leftListIds.length) {
        this.checkAll = true
        this.isIndeterminate = false
      } else if (arr.length > 0) {
        this.isIndeterminate = true
        this.checkAll = false
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
      if (arr.length === 0) {
        this.checkAll = false
        this.isIndeterminate = false
      }
    },
    //   打开弹框 初始化数据
    openD(openList = []) {
      let list = []
      if (!this.showUsers) {
        list = openList
      } else {
        list = this.chooseList
      }
      this.checkList = list.map(v => v.id)
      this.roleList = JSON.parse(JSON.stringify(list))
      this.searchInfo = ''
      this.dialogVisible = true
      this.checkAll = false
      this.isIndeterminate = false
      this.getRoleListData()
    },
    submit() {
      this.dialogVisible = false
      if (this.limit && this.roleList.length > this.limit) {
        return this.$message.error(`仅支持选择${this.limit}人`)
      }
      const roleList = deepClone(this.roleList)
      this.chooseList = roleList
      const submitList = roleList.map((item) => item.id)
      this.$emit('input', submitList)
      this.$emit('submit', submitList)
      this.$emit('validateProp')
      this.sendInfo()
    },
    // 生成分支回显数据
    sendInfo() {
      const infoList = this.roleList.map((item) => {
        return item.name
      })
      if (infoList.length > 0) {
        this.$emit('update:info', infoList.join('、'))
      } else {
        this.$emit('update:info', '')
      }
    },
    //   关闭弹框
    handleClose() {
      this.dialogVisible = false
    },
    // 全选
    handleCheckAllChange(val) {
      const leftListIds = this.leftList.map((item) => item.id)
      if (val) {
        const checkArr = []
        const roleArr = []
        this.leftList.map((item) => {
          // 需求变更：默认角色也能选择到
          if (!this.checkList.includes(item.id)) {
            checkArr.push(item.id)
            roleArr.push(item)
          }
        })
        this.checkList = cloneDeep(this.checkList.concat(checkArr))
        this.roleList = cloneDeep(this.roleList.concat(roleArr))
      } else {
        this.checkList = this.checkList.filter((item) => {
          return !leftListIds.includes(item)
        })
        this.roleList = this.roleList.filter((item) => {
          return !leftListIds.includes(item.id)
        })
      }
      this.checkAllValue()
    },
    // 选中单个
    // handleCheckedCitiesChange(value) {
    //   const checkedCount = this.checkList.checkList
    //   this.checkAll = checkedCount === this.leftList.length
    //   this.isIndeterminate = checkedCount > 0 && checkedCount < this.leftList.length
    //   console.log('value', checkedCount)
    //   if (checkedCount === 0) {
    //     this.checkAll = false
    //     this.isIndeterminate = false
    //   }
    // },
    changeCheckbox(val, item) {
      if (val) {
        this.roleList.push(item)
      } else {
        const index = this.roleList.findIndex((item2) => item2.id === item.id)
        if (index >= 0) {
          this.roleList.splice(index, 1)
        }
      }
      this.checkAllValue()
    },
    //   去重
    unique(arr) {
      return Array.from(new Set(arr))
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
/deep/.el-dialog__body {
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  padding: 0;
}
/deep/.el-tree-node__content {
  height: 40px;
}
.form-member-choose {
  .member-btn {
    .open {
      display: inline-block;
    }
    .member-list {
      &.has-user {
        padding-top: 16px;
      }
      // padding: 10px 0px;
      display: flex;
      flex-wrap: wrap;
      max-height: 200px;
      overflow-y: auto;
      /deep/img {
        width: 24px;
        height: 24px;
        object-fit: fill;
      }
      /deep/.el-tag__close {
      color: #333;
      }
      /deep/.el-tag {
        color: #333;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
          border-radius: 24px;
          vertical-align: middle;
          margin-right: 8px;
        }
        span {
          // line-height: 40px;
          display: inline-block;
          vertical-align: top;
        }
        &:hover {
          color: $wit-primary;
          background-color: $wit-opacity9;
          .el-tag__close {
            color: $wit-primary;
            background-color: $wit-opacity6;
          }
        }
      }
    }
  }
}
.member-flex {
  display: flex;
}
.member-jsb {
  justify-content: space-between;
  /deep/.el-input__validateIcon {
    display: none;
  }
}
.member-ac {
  align-items: center;
  /deep/.el-checkbox__label {
    padding-left: 0;
  }
  /deep/.el-avatar {
    min-width: 40px;
  }
}
.member {
  .member-left {
    width: 50%;
    padding: 16px;
    padding-left: 32px;
    height: 500px;
    overflow: auto;
    .scrollbar-wrapper {
      height: calc(100% - 70px);
      padding: 8px 0px;
      .role-checkbox-item {
        padding: 2px 0px;
      }
    }
    .member-left-tree {
      // width: 100%;
      margin-top: 20px;
      //  overflow-x: scroll;
    }
    /deep/.el-tree-node.is-expanded > .el-tree-node__children {
      overflow: visible;
    }
  }
  .member-right {
    width: 50%;
    border-left: 1px solid #d8d8d8;
    padding: 28px 32px 16px 16px;
    font-size: 14px;
    color: #333333;
    height: 500px;
    overflow-y: scroll;
    .checkbox-out-center {
      margin-top: 32px;
      .checkbox-out {
        margin-top: 12px;
        .checkbox-out-man {
          padding-left: 15px;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          width: 209px;
          white-space: nowrap;/*内容超宽后禁止换行显示*/
          overflow: hidden;/*超出部分隐藏*/
          text-overflow:ellipsis;/*文字超出部分以省略号显示*/
        }
      }
    }
    .member-right-all {
      margin-right: 12px;
    }
    .member-choosed {
      padding-top: 10px;
      >div {
        padding: 4px 0px;
        display: flex;
        justify-content: space-between;
        p {
          flex: 1;
        }
        i {
          cursor: pointer;
        }
      }
    }
  }
}
.el-button + .el-button {
  margin-left: 10px;
}
body.sys-deep-style {
  .member-right {
    color: #c0c4cc;
    border-left: 1px solid #848484;
    .checkbox-out-center {
      .checkbox-out {
        .checkbox-out-man {
          color: #c0c4cc;
        }
      }
    }
  }
  /deep/ .el-dialog__body {
    border-top: 1px solid #848484 !important;
    border-bottom: 1px solid #848484 !important;
  }
}
</style>
